const common = {
  "site.name": "金宝博",
  "site.slogan": "您信赖的首选平台",
  "nav.home": "首页",
  "nav.about": "关于我们",
  "nav.categories": "分类浏览",
  "nav.articles": "文章中心",
  "nav.login": "会员登录",
  "nav.register": "立即注册",
  "footer.copyright": "© 2026 金宝博 版权所有",
  "footer.about": "关于我们",
  "footer.contact": "联系我们",
  "footer.privacy": "隐私政策",
  "footer.terms": "服务条款",
  "footer.help": "帮助中心",
  "breadcrumb.home": "首页",
  "breadcrumb.categories": "分类浏览",
  "breadcrumb.articles": "文章中心",
  "breadcrumb.about": "关于我们",
  "hero.title": "金宝博 · 您信赖的首选平台",
  "hero.subtitle": "安全、便捷、专业的一站式服务平台，为全球数百万用户提供卓越体验",
  "hero.cta.register": "立即注册",
  "hero.cta.learn": "了解更多",
  "category.title": "分类浏览",
  "category.subtitle": "按主题探索金宝博的丰富内容",
  "category.all": "全部",
  "article.readMore": "阅读全文",
  "article.publishedOn": "发布时间",
  "article.author": "作者",
  "article.readTime": "阅读时长",
  "article.relatedArticles": "相关文章",
  "article.backToList": "返回列表",
  "about.title": "关于金宝博",
  "about.subtitle": "了解金宝博的品牌故事、核心价值与发展历程",
  "about.mission": "我们的使命",
  "about.vision": "我们的愿景",
  "about.values": "核心价值观",
  "about.milestones": "发展历程",
  "about.testimonials": "用户口碑",
  "about.contact": "联系我们",
  "about.faq": "常见问题",
  "stats.users": "服务用户",
  "stats.satisfaction": "用户满意度",
  "stats.awards": "行业大奖",
  "stats.coverage": "服务覆盖",
  "cta.title": "立即加入金宝博",
  "cta.subtitle": "新用户注册即享专属礼包，开启您的金宝博之旅",
  "cta.button": "免费注册",
  "seo.home.title": "金宝博官方落地页 | 金宝博品牌介绍与服务指南",
  "seo.home.description": "金宝博是您信赖的首选平台，本页全面介绍金宝博的核心服务、品牌优势、用户口碑与注册流程。无论您是新用户还是老会员，金宝博都为您提供安全、便捷、专业的一站式体验，立即了解金宝博的全部内容。",
  "seo.home.keywords": "金宝博,金宝博官网,金宝博注册,金宝博登录,金宝博会员,金宝博优惠活动,金宝博平台介绍",
  "seo.category.title": "{{name}} - 金宝博文章分类",
  "seo.category.description": "浏览金宝博{{name}}分类下的所有文章，了解金宝博平台的{{name}}相关内容。金宝博为您提供专业、安全、便捷的一站式服务体验。",
  "seo.article.title": "{{title}} - 金宝博",
  "seo.article.description": "{{excerpt}}金宝博是您信赖的首选平台，为您提供安全、便捷、专业的一站式体验。",
  "seo.about.title": "关于金宝博 | 品牌介绍、口碑与联系方式",
  "seo.about.description": "全面了解金宝博品牌故事、核心价值、发展历程与用户口碑。金宝博是行业领先的一站式服务平台，服务全球500万+用户，满意度高达98.5%，提供7×24小时专业客服支持。",
  "category.pageTitle": "{{name}}",
  "category.pageDescription": "{{description}}",
  "category.articleCount": "共 {{count}} 篇文章",
};

export default common;